import React, { useEffect } from 'react';

const AVAILABLE_CHARTS = [
  { key: 'BINANCE:BTCUSDT', label: 'BTCUSDT' },
  { key: 'BINANCE:ETHUSDT', label: 'ETHUSDT' },
  { key: 'BINANCE:ETHBTC', label: 'ETHBTC' },
  { key: 'BTC.D', label: 'BTC.D' },
  { key: 'OTHERS.D', label: 'OTHERS.D' },
  { key: 'OTHERS', label: 'OTHERS' },
  { key: 'OTHERS/BTC', label: 'OTHERS/BTC' },
  { key: 'OTHERS/ETH', label: 'OTHERS/ETH' },
  { key: 'TOTAL', label: 'TOTAL' },
  { key: 'TOTALES', label: 'TOTALES' },
  { key: 'TOTAL2', label: 'TOTAL2' },
  { key: 'TOTAL2ES', label: 'TOTAL2ES' },
  { key: 'TOTAL3', label: 'TOTAL3' },
  { key: 'TOTAL3ES', label: 'TOTAL3ES' },
  { key: 'TOTAL3ESBTC', label: 'TOTAL3ESBTC' },
];

const ChartSettingsModal = ({
  selectedCharts,
  range,
  onChange,
  onClose,
}) => {

  useEffect(() => {
    const onKeyDown = (e) => {
      if (e.key === 'Escape') onClose();
    };
    window.addEventListener('keydown', onKeyDown);
    return () => window.removeEventListener('keydown', onKeyDown);
  }, [onClose]);

  const ranges = ['4H', 'D', 'W'];

  const toggleChart = (key) => {
    const exists = selectedCharts.includes(key);
    const next = exists ? selectedCharts.filter((k) => k !== key) : [...selectedCharts, key];
    onChange({ selectedCharts: next });
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black bg-opacity-50" role="dialog" aria-modal="true" onClick={onClose}>
      <div className="relative w-full max-w-lg rounded-lg bg-white dark:bg-gray-800 shadow-xl" onClick={(e) => e.stopPropagation()}>
        <button
          aria-label="Close"
          onClick={onClose}
          className="absolute top-3 right-3 text-gray-500 hover:text-gray-700 dark:text-gray-400 dark:hover:text-gray-200"
        >
          ×
        </button>
        <div className="p-6 border-b border-gray-200 dark:border-gray-700">
          <h3 className="text-lg font-semibold text-gray-900 dark:text-gray-100">Customize Charts</h3>
        </div>
        <div className="p-6 space-y-6">
          <div>
            <div className="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">Default chart range</div>
            <div className="flex items-center space-x-2">
              {ranges.map((r) => (
                <button
                  key={r}
                  onClick={() => onChange({ range: r })}
                  className={(r === range ? 'bg-blue-600 text-white' : 'bg-gray-100 dark:bg-gray-700 text-gray-800 dark:text-gray-200') + ' px-3 py-1.5 rounded-md'}
                >{r}</button>
              ))}
            </div>
          </div>

          <div>
            <div className="mb-2 text-sm font-medium text-gray-700 dark:text-gray-300">Favorite charts</div>
            <div className="grid grid-cols-2 gap-2">
              {AVAILABLE_CHARTS.map(({ key, label }) => {
                const active = selectedCharts.includes(key);
                return (
                  <button
                    key={key}
                    onClick={() => toggleChart(key)}
                    className={(active ? 'border-blue-500 bg-blue-50 dark:bg-blue-900/20' : 'border-gray-300 dark:border-gray-600') + ' flex items-center justify-between border rounded-md px-3 py-2 text-sm text-gray-800 dark:text-gray-200'}
                  >
                    <span>{label}</span>
                    {active && <span className="text-blue-600">✓</span>}
                  </button>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChartSettingsModal;


